/**
 * LogTipoTabela
 */

export enum LogTipoTabela {
  LEGACY_CONTAS_PAGAR = 0,
  LEGACY_COLETA_PRECO = 1,
  LEGACY_MEDICAO_TERCEIRIZACAO = 2,
  LEGACY_INSPECAO_OBRA = 3,
  LEGACY_FORNECEDOR = 4,
  LEGACY_ARQUIVO_MODULO = 5,
  LEGACY_ENTREGA_OBRA_VERIFICACAO = 6,
  LEGACY_INFORMACOES_GERAIS_OBRA = 7,
  LEGACY_REQUISICAO_COMPRA = 8,
  LEGACY_INDICE_REAJUSTE = 9,
  LEGACY_CONTRATO_FINANCEIRO = 10,
  LEGACY_GRUPO_ACESSO = 11,
  LEGACY_CONTAS_RECEBER = 12,
  LEGACY_PROJETO = 13,
  LEGACY_PROJETO_INFORMACOES = 14,
  LEGACY_PROJETO_ARQUIVO = 15,
  LEGACY_PROJETO_DISCIPLINA = 16,
  LEGACY_DISCIPLINA_CHECKLIST = 17,
  LEGACY_TREINAMENTO = 18,
  ACAO_PREV_CORRETIVA = 19,
  ACAO_QUALIDADE = 20,
  ALTERACAO_REQUISICAO_PRODUTO_SERVICO = 21,
  ALVENARIA_OBRA = 22,
  ARMAZENAMENTO = 23,
  ARQUIVO_GENERICO = 24,
  ARQUIVO_GERAL = 25,
  ARQUIVO_MODULO = 26,
  ARQUIVO_VERSAO_SISTEMA = 27,
  ASSISTENCIA_ARQUIVO = 28,
  ASSISTENCIA_ATENDIMENTO = 29,
  ASSISTENCIA_TECNICA = 30,
  ASSISTENCIA_TECNICA_CATEGORIA = 31,
  ATIVIDADE_OBRA = 32,
  ATRIBUICAO = 33,
  ATRIBUICAO_GRUPO = 34,
  ATRIBUTOS_COMPRAS = 35,
  ATRIBUTOS_OBRAS = 36,
  ATRIBUTOS_SISTEMA = 37,
  AUDITOR = 38,
  AUDITORIA = 39,
  AVALIACAO_FORNECEDOR = 40,
  AVALIACAO_HABILIDADE = 41,
  BANCO = 42,
  BANCO_PAGAMENTO = 43,
  BCK_PERMISSAO = 44,
  CANAIS_ATENDIMENTO = 45,
  CARGO = 46,
  CARGO_HABILIDADE = 47,
  CARGO_TREINAMENTO = 48,
  CATEGORIA_ASSISTENCIA = 49,
  CENTRO_CUSTO = 50,
  CENTRO_CUSTO_ENDERECO = 51,
  CGD_PRODUTOS_02072015 = 52,
  CGD_PRODUTOS_02072015_B = 53,
  CHECKLIST = 54,
  CHECKLIST_ENTREGA = 55,
  CHECKLIST_SERVICO = 56,
  CLIENTE = 57,
  CLIENTE_ARQUIVO = 58,
  CLIENTE_CENTRO_CUSTO = 59,
  COLETA_PRECO = 60,
  COLETA_PRECO_FORNECEDOR = 61,
  COLETA_PRODUTO_SERVICO = 62,
  CONFIGURACAO_CLIENTES = 63,
  CONFIGURACAO_CLIENTES_ACESSOS = 64,
  CONTAS_PAGAR = 65,
  CONTAS_RECEBER = 66,
  CONTRATO = 67,
  CONTRATO_ARQUIVO = 68,
  CONTRATO_FINANCEIRO = 69,
  CONTRATO_INFORMACOES = 70,
  CONTRATO_SERVICO = 71,
  CONTROLE_AGUA = 72,
  CONTROLE_BILIOTECA = 73,
  CONTROLE_CENTRO_CUSTO = 74,
  CONTROLE_DE_PATRIMÔNIO_FINAL = 75,
  CONTROLE_ENERGIA = 76,
  CONTROLE_ESTOQUE = 77,
  CONTROLE_PATRIMONIO = 78,
  CONTROLE_RESIDUOS = 79,
  CRITERIO_AVALIACAO_FORNECEDOR = 80,
  CRONOGRAMA = 81,
  CRONOGRAMA_CHECKLIST = 82,
  CRONOGRAMA_ITEM_CHECKLIST = 83,
  CRONOGRAMA_SGQ = 84,
  DESCRICAO_MES = 85,
  DIARIO_OBRAS = 86,
  DIARIO_OBRAS_ATIVIDADES = 87,
  DIARIO_OBRAS_EFETIVO = 88,
  DIARIO_OBRAS_EQUIPAMENTOS = 89,
  DIARIO_OBRAS_IMAGENS = 90,
  DIARIO_OBRAS_PARALISACOES = 91,
  DIM_TEMPO = 92,
  DIM_TEMPODIA_FULL = 93,
  DISCIPLINA = 94,
  DISCIPLINA_ARQUIVO = 95,
  DISCIPLINA_CHECKLIST = 96,
  DISCIPLINA_ITEM_CHECKLIST = 97,
  DOCUMENTOS = 98,
  ENDERECO = 99,
  ENTRADA_PRODUTO = 100,
  ENTREGA_OBRA = 101,
  ENTREGA_OBRA_CLIENTE = 102,
  ENTREGA_OBRA_CLIENTE_ARQUIVO = 103,
  ENTREGA_OBRA_CLIENTE_ARQUIVO_AUX = 104,
  ENTREGA_OBRA_CLIENTE_PESQUISA_SATISFACAO = 105,
  ENTREGA_OBRA_CLIENTE_TERMO = 106,
  EQUIPAMENTO_MEDICAO = 107,
  ESPECIFICIDADE_OBRA = 108,
  ESTRUTURA_ORGANIZACIONAL = 109,
  EXECUTADO_POR = 110,
  EXECUTADO_POR_FUNCIONARIO = 111,
  FILTRO_CONTAS_PAGAR = 112,
  FILTRO_CONTAS_RECEBER = 113,
  FILTRO_FOLHA_PGTO = 114,
  FOLHA_PAGAMENTO = 115,
  FORNECEDOR = 116,
  FORNECEDOR_ARQUIVO = 117,
  FUNCIONARIO = 118,
  FUNCIONARIO_AFASTAMENTO = 119,
  FUNCIONARIO_ARQUIVO = 120,
  FUNCIONARIO_ASSINATURA = 121,
  FUNCIONARIO_CENTRO_CUSTO = 122,
  FUNCIONARIO_DEPENDENTE = 123,
  FUNCIONARIO_DOCUMENTOS = 124,
  FUNCIONARIO_FERIAS = 125,
  FUNCIONARIO_HABILIDADE = 126,
  FUNCIONARIO_TERC = 127,
  FUNCIONARIO_TERC_ARQUIVO = 128,
  FUNCIONARIO_TERC_CENTRO_CUSTO = 129,
  FUNCIONARIO_TERC_TREINAMENTO = 130,
  FUNCIONARIO_TREINAMENTO = 131,
  GED = 132,
  GESTAO_RESIDUOS = 133,
  GRUPO_ACESSO = 134,
  HABILIDADE = 135,
  INDICADOR = 136,
  INDICE_REAJUSTE = 137,
  INFORMACAO_FATURAMENTO = 138,
  INFORMACOES = 139,
  INFORMACOES_ENTREGA_OBRA_CLIENTE = 140,
  INFORMACOES_INSPECAO_OBRA = 141,
  INSPECAO_MAQUINA_EQUIP = 142,
  INSPECAO_MAQUINA_EQUIP_ITENS = 143,
  INSPECAO_OBRA = 144,
  INSPECAO_OBRA_ITENS = 145,
  ITEM_AVALIACAO_FORNECEDOR = 146,
  ITEM_CHECKLIST = 147,
  ITEM_CHECKLIST_ENTREGA = 148,
  ITEM_CHECKLIST_SERVICO = 149,
  ITEM_CHECKLIST_SERVICO_RESUMO = 150,
  ITEM_CONTROLE_BIBLIOTECA = 151,
  ITEM_CONTROLE_ESTOQUE = 152,
  ITEM_FOLHA_PAGAMENTO = 153,
  ITEM_FOLHA_PAGAMENTO_VERBA = 154,
  ITEM_MAQUINA_EQUIP = 155,
  ITEM_MEDICAO_TERCEIRIZACAO = 156,
  ITEM_PESQUISA_CLIENTE = 157,
  ITEM_PESQUISA_ENTREGA_OBRA = 158,
  ITEM_PESQUISA_SATISFACAO = 159,
  ITEM_PLANEJAMENTO = 160,
  ITEM_PROCESSO = 161,
  ITEM_PROCESSO_FATOR = 162,
  ITEM_PROCESSO_INDICADOR = 163,
  ITEM_PROCESSO_INTERESSE = 164,
  ITEM_VERBA = 165,
  ITEM_VERBA_FUNCIONARIO = 166,
  LIVRO = 167,
  LOG_ACESSO_SISTEMA = 168,
  LOG_ALTERACAO = 169,
  LOG_ENVIO_EMAIL = 170,
  MANUTENCAO_EQUIP_OBRA = 171,
  MAPA_CONCRETAGEM = 172,
  MAQUINA_EQUIP = 173,
  MAQUINA_EQUIP_ARQUIVO = 174,
  MATERIAIS_CONTROLADOS = 175,
  MEDICAO_TERCEIRIZACAO = 176,
  MODULO_SISTEMA = 177,
  MOTIVO_AFASTAMENTO = 178,
  MOTIVO_DEMISSAO = 179,
  NOTIFICACOES_SGQ_MOBILE = 180,
  NOVOS_NEGOCIOS = 181,
  NOVOS_NEGOCIOS_ARQUIVO = 182,
  OBRA = 183,
  OBRA_AREA_CHECKLIST = 184,
  OBRA_ARQUIVO = 185,
  OBRA_CHECKLIST_SERVICO = 186,
  OBRA_INDICADOR = 187,
  OBRA_INFORMACOES = 188,
  OBRA_MATERIAIS_CONTROLADOS = 189,
  OBRA_SERVICOS_CONTROLADOS = 190,
  ORDEM_COMPRA = 191,
  ORDEM_COMPRA_PRODUTO_SERVICO = 192,
  PERMISSAO_GRUPO_TELA = 193,
  PESQUISA_SATISFACAO = 194,
  PESQUISA_SATISFACAO_CLIENTE = 195,
  PGTO_COLETA = 196,
  PGTO_CONTRATO_FINANCEIRO = 197,
  PGTO_MEDICAO = 198,
  PLANEJAMENTO = 199,
  PLANO_TREINAMENTO = 200,
  PROCESSO = 201,
  PROCESSO_AUDITORIA = 202,
  PRODUTO_SERVICO = 203,
  PRODUTO_SERVICO_ENTREGUE = 204,
  PROJETO = 205,
  PROJETO_ARQUIVO = 206,
  PROJETO_IMPRESSAO = 207,
  PROJETO_IMPRESSAO_DISCIPLINA = 208,
  PROJETO_REVISAO = 209,
  PROJETO_REVISAO_DISCIPLINA = 210,
  PROVISAO_RECURSO = 211,
  QUALIFICACAO = 212,
  QUALIFICACAO_FORNECEDOR = 213,
  RATEIO_GERAL = 214,
  REAJUSTE = 215,
  REQUISICAO_COMPRA = 216,
  REQUISICAO_PRODUTO_SERVICO = 217,
  SAIDA_PRODUTO = 218,
  SALDO_BANCARIO = 219,
  SATISFACAO_CLIENTE = 220,
  SEGURANCA_TRABALHO = 221,
  SERVICOS_CONTROLADOS = 222,
  SESSAO_ACESSO = 223,
  SETOR = 224,
  STATUS_ENVIO_EMAIL = 225,
  SUB_DISCIPLINA = 226,
  SUB_DISCIPLINA_CHECKLIST = 227,
  SUB_DISCIPLINA_ITEM_CHECKLIST = 228,
  SUBCONTA = 229,
  TELA_SISTEMA = 230,
  TEMP_FUNC_TERC = 231,
  TEMP_IDEAL = 232,
  TERMO = 233,
  TIPO_CONTA = 234,
  TIPO_EXAME = 235,
  TREINAMENTO = 236,
  USUARIO = 237,
  USUARIO_CENTRO_CUSTO = 238,
  USUARIO_GRUPO = 239,
  VERIFICACAO_CHECKLIST = 240,
  EMPREENDIMENTO = 241,
  INCORPORACAO_ANDAR = 242,
  INCORPORACAO_IMOVEL = 243,
  INCORPORACAO_BLOCO = 244,
  CONTAS_RECEBER_PARCIAL = 245,
  PROJETO_REVISAO_RESUMO = 246,
  MANUTENCAO = 247,
  CHECKLIST_ENTREGA_AMBIENTE = 248,
  EQUIPAMENTO_MEDICAO_HISTORICO = 249,
  CADASTRO_COR = 250,
  GESTAO_EPI = 251,
  GESTAO_RECEBIMENTO_EPI = 252,
  GESTAO_DISTRIBUICAO_EPI = 253,
  CHECKLIST_SERVICO_AMBIENTE = 254,
  BIOMETRIA_FACIAL = 255,
  COLETA_PRECO_APROVADOR = 256,
  FUNCIONARIO_APROVADOR = 257,
  CHECKLIST_MAQUINA_EQUIP = 258,
  ITEM_CHECKLIST_MAQUINA_EQUIP = 259,
  PATRIMONIO_CENTRO_CUSTO = 260,
  PATRIMONIO_MAQUINA_EQUIP = 261,
  PATRIMONIO_CHECKLIST_MAQUINA_EQUIP = 262,
  INSPECAO_PATRIMONIO = 263,
  INSPECAO_PATRIMONIO_ITENS = 264,
  OCORRENCIA_INSPECAO_PATRIMONIO = 265,
  CHECKLIST_SERVICO_LIBERACAO = 266,
}

/**
 * LogTipoAcao
 */

export enum LogTipoAcao {
  INCLUSAO,
  EDICAO,
  DELECAO,
  RESTAURACAO,
}

/**
 * logTipoTabelaToString
 */

export const logTipoTabelaToString = (logTabelaTipo: LogTipoTabela): string => {
  switch (logTabelaTipo) {
    case LogTipoTabela.LEGACY_CONTAS_PAGAR: return "LEGACY_CONTAS_PAGAR";
    case LogTipoTabela.LEGACY_COLETA_PRECO: return "LEGACY_COLETA_PRECO";
    case LogTipoTabela.LEGACY_MEDICAO_TERCEIRIZACAO: return "LEGACY_MEDICAO_TERCEIRIZACAO";
    case LogTipoTabela.LEGACY_INSPECAO_OBRA: return "LEGACY_INSPECAO_OBRA";
    case LogTipoTabela.LEGACY_FORNECEDOR: return "LEGACY_FORNECEDOR";
    case LogTipoTabela.LEGACY_ARQUIVO_MODULO: return "LEGACY_ARQUIVO_MODULO";
    case LogTipoTabela.LEGACY_ENTREGA_OBRA_VERIFICACAO: return "LEGACY_ENTREGA_OBRA_VERIFICACAO";
    case LogTipoTabela.LEGACY_INFORMACOES_GERAIS_OBRA: return "LEGACY_INFORMACOES_GERAIS_OBRA";
    case LogTipoTabela.LEGACY_REQUISICAO_COMPRA: return "LEGACY_REQUISICAO_COMPRA";
    case LogTipoTabela.LEGACY_INDICE_REAJUSTE: return "LEGACY_INDICE_REAJUSTE";
    case LogTipoTabela.LEGACY_CONTRATO_FINANCEIRO: return "LEGACY_CONTRATO_FINANCEIRO";
    case LogTipoTabela.LEGACY_GRUPO_ACESSO: return "LEGACY_GRUPO_ACESSO";
    case LogTipoTabela.LEGACY_CONTAS_RECEBER: return "LEGACY_CONTAS_RECEBER";
    case LogTipoTabela.LEGACY_PROJETO: return "LEGACY_PROJETO";
    case LogTipoTabela.LEGACY_PROJETO_INFORMACOES: return "LEGACY_PROJETO_INFORMACOES";
    case LogTipoTabela.LEGACY_PROJETO_ARQUIVO: return "LEGACY_PROJETO_ARQUIVO";
    case LogTipoTabela.LEGACY_PROJETO_DISCIPLINA: return "LEGACY_PROJETO_DISCIPLINA";
    case LogTipoTabela.LEGACY_DISCIPLINA_CHECKLIST: return "LEGACY_DISCIPLINA_CHECKLIST";
    case LogTipoTabela.LEGACY_TREINAMENTO: return "LEGACY_TREINAMENTO";
    case LogTipoTabela.ACAO_PREV_CORRETIVA: return "ACAO_PREV_CORRETIVA";
    case LogTipoTabela.ACAO_QUALIDADE: return "ACAO_QUALIDADE";
    case LogTipoTabela.ALTERACAO_REQUISICAO_PRODUTO_SERVICO: return "ALTERACAO_REQUISICAO_PRODUTO_SERVICO";
    case LogTipoTabela.ALVENARIA_OBRA: return "ALVENARIA_OBRA";
    case LogTipoTabela.ARMAZENAMENTO: return "ARMAZENAMENTO";
    case LogTipoTabela.ARQUIVO_GENERICO: return "ARQUIVO_GENERICO";
    case LogTipoTabela.ARQUIVO_GERAL: return "ARQUIVO_GERAL";
    case LogTipoTabela.ARQUIVO_MODULO: return "ARQUIVO_MODULO";
    case LogTipoTabela.ARQUIVO_VERSAO_SISTEMA: return "ARQUIVO_VERSAO_SISTEMA";
    case LogTipoTabela.ASSISTENCIA_ARQUIVO: return "ASSISTENCIA_ARQUIVO";
    case LogTipoTabela.ASSISTENCIA_ATENDIMENTO: return "ASSISTENCIA_ATENDIMENTO";
    case LogTipoTabela.ASSISTENCIA_TECNICA: return "ASSISTENCIA_TECNICA";
    case LogTipoTabela.ASSISTENCIA_TECNICA_CATEGORIA: return "ASSISTENCIA_TECNICA_CATEGORIA";
    case LogTipoTabela.ATIVIDADE_OBRA: return "ATIVIDADE_OBRA";
    case LogTipoTabela.ATRIBUICAO: return "ATRIBUICAO";
    case LogTipoTabela.ATRIBUICAO_GRUPO: return "ATRIBUICAO_GRUPO";
    case LogTipoTabela.ATRIBUTOS_COMPRAS: return "ATRIBUTOS_COMPRAS";
    case LogTipoTabela.ATRIBUTOS_OBRAS: return "ATRIBUTOS_OBRAS";
    case LogTipoTabela.ATRIBUTOS_SISTEMA: return "ATRIBUTOS_SISTEMA";
    case LogTipoTabela.AUDITOR: return "AUDITOR";
    case LogTipoTabela.AUDITORIA: return "AUDITORIA";
    case LogTipoTabela.AVALIACAO_FORNECEDOR: return "AVALIACAO_FORNECEDOR";
    case LogTipoTabela.AVALIACAO_HABILIDADE: return "AVALIACAO_HABILIDADE";
    case LogTipoTabela.BANCO: return "BANCO";
    case LogTipoTabela.BANCO_PAGAMENTO: return "BANCO_PAGAMENTO";
    case LogTipoTabela.BCK_PERMISSAO: return "BCK_PERMISSAO";
    case LogTipoTabela.CANAIS_ATENDIMENTO: return "CANAIS_ATENDIMENTO";
    case LogTipoTabela.CARGO: return "CARGO";
    case LogTipoTabela.CARGO_HABILIDADE: return "CARGO_HABILIDADE";
    case LogTipoTabela.CARGO_TREINAMENTO: return "CARGO_TREINAMENTO";
    case LogTipoTabela.CATEGORIA_ASSISTENCIA: return "CATEGORIA_ASSISTENCIA";
    case LogTipoTabela.CENTRO_CUSTO: return "CENTRO_CUSTO";
    case LogTipoTabela.CENTRO_CUSTO_ENDERECO: return "CENTRO_CUSTO_ENDERECO";
    case LogTipoTabela.CGD_PRODUTOS_02072015: return "CGD_PRODUTOS_02072015";
    case LogTipoTabela.CGD_PRODUTOS_02072015_B: return "CGD_PRODUTOS_02072015_B";
    case LogTipoTabela.CHECKLIST: return "CHECKLIST";
    case LogTipoTabela.CHECKLIST_ENTREGA: return "CHECKLIST_ENTREGA";
    case LogTipoTabela.CHECKLIST_SERVICO: return "CHECKLIST_SERVICO";
    case LogTipoTabela.CLIENTE: return "CLIENTE";
    case LogTipoTabela.CLIENTE_ARQUIVO: return "CLIENTE_ARQUIVO";
    case LogTipoTabela.CLIENTE_CENTRO_CUSTO: return "CLIENTE_CENTRO_CUSTO";
    case LogTipoTabela.COLETA_PRECO: return "COLETA_PRECO";
    case LogTipoTabela.COLETA_PRECO_FORNECEDOR: return "COLETA_PRECO_FORNECEDOR";
    case LogTipoTabela.COLETA_PRODUTO_SERVICO: return "COLETA_PRODUTO_SERVICO";
    case LogTipoTabela.CONFIGURACAO_CLIENTES: return "CONFIGURACAO_CLIENTES";
    case LogTipoTabela.CONFIGURACAO_CLIENTES_ACESSOS: return "CONFIGURACAO_CLIENTES_ACESSOS";
    case LogTipoTabela.CONTAS_PAGAR: return "CONTAS_PAGAR";
    case LogTipoTabela.CONTAS_RECEBER: return "CONTAS_RECEBER";
    case LogTipoTabela.CONTRATO: return "CONTRATO";
    case LogTipoTabela.CONTRATO_ARQUIVO: return "CONTRATO_ARQUIVO";
    case LogTipoTabela.CONTRATO_FINANCEIRO: return "CONTRATO_FINANCEIRO";
    case LogTipoTabela.CONTRATO_INFORMACOES: return "CONTRATO_INFORMACOES";
    case LogTipoTabela.CONTRATO_SERVICO: return "CONTRATO_SERVICO";
    case LogTipoTabela.CONTROLE_AGUA: return "CONTROLE_AGUA";
    case LogTipoTabela.CONTROLE_BILIOTECA: return "CONTROLE_BILIOTECA";
    case LogTipoTabela.CONTROLE_CENTRO_CUSTO: return "CONTROLE_CENTRO_CUSTO";
    case LogTipoTabela.CONTROLE_DE_PATRIMÔNIO_FINAL: return "CONTROLE_DE_PATRIMÔNIO_FINAL";
    case LogTipoTabela.CONTROLE_ENERGIA: return "CONTROLE_ENERGIA";
    case LogTipoTabela.CONTROLE_ESTOQUE: return "CONTROLE_ESTOQUE";
    case LogTipoTabela.CONTROLE_PATRIMONIO: return "CONTROLE_PATRIMONIO";
    case LogTipoTabela.CONTROLE_RESIDUOS: return "CONTROLE_RESIDUOS";
    case LogTipoTabela.CRITERIO_AVALIACAO_FORNECEDOR: return "CRITERIO_AVALIACAO_FORNECEDOR";
    case LogTipoTabela.CRONOGRAMA: return "CRONOGRAMA";
    case LogTipoTabela.CRONOGRAMA_CHECKLIST: return "CRONOGRAMA_CHECKLIST";
    case LogTipoTabela.CRONOGRAMA_ITEM_CHECKLIST: return "CRONOGRAMA_ITEM_CHECKLIST";
    case LogTipoTabela.CRONOGRAMA_SGQ: return "CRONOGRAMA_SGQ";
    case LogTipoTabela.DESCRICAO_MES: return "DESCRICAO_MES";
    case LogTipoTabela.DIARIO_OBRAS: return "DIARIO_OBRAS";
    case LogTipoTabela.DIARIO_OBRAS_ATIVIDADES: return "DIARIO_OBRAS_ATIVIDADES";
    case LogTipoTabela.DIARIO_OBRAS_EFETIVO: return "DIARIO_OBRAS_EFETIVO";
    case LogTipoTabela.DIARIO_OBRAS_EQUIPAMENTOS: return "DIARIO_OBRAS_EQUIPAMENTOS";
    case LogTipoTabela.DIARIO_OBRAS_IMAGENS: return "DIARIO_OBRAS_IMAGENS";
    case LogTipoTabela.DIARIO_OBRAS_PARALISACOES: return "DIARIO_OBRAS_PARALISACOES";
    case LogTipoTabela.DIM_TEMPO: return "DIM_TEMPO";
    case LogTipoTabela.DIM_TEMPODIA_FULL: return "DIM_TEMPODIA_FULL";
    case LogTipoTabela.DISCIPLINA: return "DISCIPLINA";
    case LogTipoTabela.DISCIPLINA_ARQUIVO: return "DISCIPLINA_ARQUIVO";
    case LogTipoTabela.DISCIPLINA_CHECKLIST: return "DISCIPLINA_CHECKLIST";
    case LogTipoTabela.DISCIPLINA_ITEM_CHECKLIST: return "DISCIPLINA_ITEM_CHECKLIST";
    case LogTipoTabela.DOCUMENTOS: return "DOCUMENTOS";
    case LogTipoTabela.ENDERECO: return "ENDERECO";
    case LogTipoTabela.ENTRADA_PRODUTO: return "ENTRADA_PRODUTO";
    case LogTipoTabela.ENTREGA_OBRA: return "ENTREGA_OBRA";
    case LogTipoTabela.ENTREGA_OBRA_CLIENTE: return "ENTREGA_OBRA_CLIENTE";
    case LogTipoTabela.ENTREGA_OBRA_CLIENTE_ARQUIVO: return "ENTREGA_OBRA_CLIENTE_ARQUIVO";
    case LogTipoTabela.ENTREGA_OBRA_CLIENTE_ARQUIVO_AUX: return "ENTREGA_OBRA_CLIENTE_ARQUIVO_AUX";
    case LogTipoTabela.ENTREGA_OBRA_CLIENTE_PESQUISA_SATISFACAO: return "ENTREGA_OBRA_CLIENTE_PESQUISA_SATISFACAO";
    case LogTipoTabela.ENTREGA_OBRA_CLIENTE_TERMO: return "ENTREGA_OBRA_CLIENTE_TERMO";
    case LogTipoTabela.EQUIPAMENTO_MEDICAO: return "EQUIPAMENTO_MEDICAO";
    case LogTipoTabela.ESPECIFICIDADE_OBRA: return "ESPECIFICIDADE_OBRA";
    case LogTipoTabela.ESTRUTURA_ORGANIZACIONAL: return "ESTRUTURA_ORGANIZACIONAL";
    case LogTipoTabela.EXECUTADO_POR: return "EXECUTADO_POR";
    case LogTipoTabela.EXECUTADO_POR_FUNCIONARIO: return "EXECUTADO_POR_FUNCIONARIO";
    case LogTipoTabela.FILTRO_CONTAS_PAGAR: return "FILTRO_CONTAS_PAGAR";
    case LogTipoTabela.FILTRO_CONTAS_RECEBER: return "FILTRO_CONTAS_RECEBER";
    case LogTipoTabela.FILTRO_FOLHA_PGTO: return "FILTRO_FOLHA_PGTO";
    case LogTipoTabela.FOLHA_PAGAMENTO: return "FOLHA_PAGAMENTO";
    case LogTipoTabela.FORNECEDOR: return "FORNECEDOR";
    case LogTipoTabela.FORNECEDOR_ARQUIVO: return "FORNECEDOR_ARQUIVO";
    case LogTipoTabela.FUNCIONARIO: return "FUNCIONARIO";
    case LogTipoTabela.FUNCIONARIO_AFASTAMENTO: return "FUNCIONARIO_AFASTAMENTO";
    case LogTipoTabela.FUNCIONARIO_ARQUIVO: return "FUNCIONARIO_ARQUIVO";
    case LogTipoTabela.FUNCIONARIO_ASSINATURA: return "FUNCIONARIO_ASSINATURA";
    case LogTipoTabela.FUNCIONARIO_CENTRO_CUSTO: return "FUNCIONARIO_CENTRO_CUSTO";
    case LogTipoTabela.FUNCIONARIO_DEPENDENTE: return "FUNCIONARIO_DEPENDENTE";
    case LogTipoTabela.FUNCIONARIO_DOCUMENTOS: return "FUNCIONARIO_DOCUMENTOS";
    case LogTipoTabela.FUNCIONARIO_FERIAS: return "FUNCIONARIO_FERIAS";
    case LogTipoTabela.FUNCIONARIO_HABILIDADE: return "FUNCIONARIO_HABILIDADE";
    case LogTipoTabela.FUNCIONARIO_TERC: return "FUNCIONARIO_TERC";
    case LogTipoTabela.FUNCIONARIO_TERC_ARQUIVO: return "FUNCIONARIO_TERC_ARQUIVO";
    case LogTipoTabela.FUNCIONARIO_TERC_CENTRO_CUSTO: return "FUNCIONARIO_TERC_CENTRO_CUSTO";
    case LogTipoTabela.FUNCIONARIO_TERC_TREINAMENTO: return "FUNCIONARIO_TERC_TREINAMENTO";
    case LogTipoTabela.FUNCIONARIO_TREINAMENTO: return "FUNCIONARIO_TREINAMENTO";
    case LogTipoTabela.GED: return "GED";
    case LogTipoTabela.GESTAO_RESIDUOS: return "GESTAO_RESIDUOS";
    case LogTipoTabela.GRUPO_ACESSO: return "GRUPO_ACESSO";
    case LogTipoTabela.HABILIDADE: return "HABILIDADE";
    case LogTipoTabela.INDICADOR: return "INDICADOR";
    case LogTipoTabela.INDICE_REAJUSTE: return "INDICE_REAJUSTE";
    case LogTipoTabela.INFORMACAO_FATURAMENTO: return "INFORMACAO_FATURAMENTO";
    case LogTipoTabela.INFORMACOES: return "INFORMACOES";
    case LogTipoTabela.INFORMACOES_ENTREGA_OBRA_CLIENTE: return "INFORMACOES_ENTREGA_OBRA_CLIENTE";
    case LogTipoTabela.INFORMACOES_INSPECAO_OBRA: return "INFORMACOES_INSPECAO_OBRA";
    case LogTipoTabela.INSPECAO_MAQUINA_EQUIP: return "INSPECAO_MAQUINA_EQUIP";
    case LogTipoTabela.INSPECAO_MAQUINA_EQUIP_ITENS: return "INSPECAO_MAQUINA_EQUIP_ITENS";
    case LogTipoTabela.INSPECAO_OBRA: return "INSPECAO_OBRA";
    case LogTipoTabela.INSPECAO_OBRA_ITENS: return "INSPECAO_OBRA_ITENS";
    case LogTipoTabela.ITEM_AVALIACAO_FORNECEDOR: return "ITEM_AVALIACAO_FORNECEDOR";
    case LogTipoTabela.ITEM_CHECKLIST: return "ITEM_CHECKLIST";
    case LogTipoTabela.ITEM_CHECKLIST_ENTREGA: return "ITEM_CHECKLIST_ENTREGA";
    case LogTipoTabela.ITEM_CHECKLIST_SERVICO: return "ITEM_CHECKLIST_SERVICO";
    case LogTipoTabela.ITEM_CHECKLIST_SERVICO_RESUMO: return "ITEM_CHECKLIST_SERVICO_RESUMO";
    case LogTipoTabela.ITEM_CONTROLE_BIBLIOTECA: return "ITEM_CONTROLE_BIBLIOTECA";
    case LogTipoTabela.ITEM_CONTROLE_ESTOQUE: return "ITEM_CONTROLE_ESTOQUE";
    case LogTipoTabela.ITEM_FOLHA_PAGAMENTO: return "ITEM_FOLHA_PAGAMENTO";
    case LogTipoTabela.ITEM_FOLHA_PAGAMENTO_VERBA: return "ITEM_FOLHA_PAGAMENTO_VERBA";
    case LogTipoTabela.ITEM_MAQUINA_EQUIP: return "ITEM_MAQUINA_EQUIP";
    case LogTipoTabela.ITEM_MEDICAO_TERCEIRIZACAO: return "ITEM_MEDICAO_TERCEIRIZACAO";
    case LogTipoTabela.ITEM_PESQUISA_CLIENTE: return "ITEM_PESQUISA_CLIENTE";
    case LogTipoTabela.ITEM_PESQUISA_ENTREGA_OBRA: return "ITEM_PESQUISA_ENTREGA_OBRA";
    case LogTipoTabela.ITEM_PESQUISA_SATISFACAO: return "ITEM_PESQUISA_SATISFACAO";
    case LogTipoTabela.ITEM_PLANEJAMENTO: return "ITEM_PLANEJAMENTO";
    case LogTipoTabela.ITEM_PROCESSO: return "ITEM_PROCESSO";
    case LogTipoTabela.ITEM_PROCESSO_FATOR: return "ITEM_PROCESSO_FATOR";
    case LogTipoTabela.ITEM_PROCESSO_INDICADOR: return "ITEM_PROCESSO_INDICADOR";
    case LogTipoTabela.ITEM_PROCESSO_INTERESSE: return "ITEM_PROCESSO_INTERESSE";
    case LogTipoTabela.ITEM_VERBA: return "ITEM_VERBA";
    case LogTipoTabela.ITEM_VERBA_FUNCIONARIO: return "ITEM_VERBA_FUNCIONARIO";
    case LogTipoTabela.LIVRO: return "LIVRO";
    case LogTipoTabela.LOG_ACESSO_SISTEMA: return "LOG_ACESSO_SISTEMA";
    case LogTipoTabela.LOG_ALTERACAO: return "LOG_ALTERACAO";
    case LogTipoTabela.LOG_ENVIO_EMAIL: return "LOG_ENVIO_EMAIL";
    case LogTipoTabela.MANUTENCAO_EQUIP_OBRA: return "MANUTENCAO_EQUIP_OBRA";
    case LogTipoTabela.MAPA_CONCRETAGEM: return "MAPA_CONCRETAGEM";
    case LogTipoTabela.MAQUINA_EQUIP: return "MAQUINA_EQUIP";
    case LogTipoTabela.MAQUINA_EQUIP_ARQUIVO: return "MAQUINA_EQUIP_ARQUIVO";
    case LogTipoTabela.MATERIAIS_CONTROLADOS: return "MATERIAIS_CONTROLADOS";
    case LogTipoTabela.MEDICAO_TERCEIRIZACAO: return "MEDICAO_TERCEIRIZACAO";
    case LogTipoTabela.MODULO_SISTEMA: return "MODULO_SISTEMA";
    case LogTipoTabela.MOTIVO_AFASTAMENTO: return "MOTIVO_AFASTAMENTO";
    case LogTipoTabela.MOTIVO_DEMISSAO: return "MOTIVO_DEMISSAO";
    case LogTipoTabela.NOTIFICACOES_SGQ_MOBILE: return "NOTIFICACOES_SGQ_MOBILE";
    case LogTipoTabela.NOVOS_NEGOCIOS: return "NOVOS_NEGOCIOS";
    case LogTipoTabela.NOVOS_NEGOCIOS_ARQUIVO: return "NOVOS_NEGOCIOS_ARQUIVO";
    case LogTipoTabela.OBRA: return "OBRA";
    case LogTipoTabela.OBRA_AREA_CHECKLIST: return "OBRA_AREA_CHECKLIST";
    case LogTipoTabela.OBRA_ARQUIVO: return "OBRA_ARQUIVO";
    case LogTipoTabela.OBRA_CHECKLIST_SERVICO: return "OBRA_CHECKLIST_SERVICO";
    case LogTipoTabela.OBRA_INDICADOR: return "OBRA_INDICADOR";
    case LogTipoTabela.OBRA_INFORMACOES: return "OBRA_INFORMACOES";
    case LogTipoTabela.OBRA_MATERIAIS_CONTROLADOS: return "OBRA_MATERIAIS_CONTROLADOS";
    case LogTipoTabela.OBRA_SERVICOS_CONTROLADOS: return "OBRA_SERVICOS_CONTROLADOS";
    case LogTipoTabela.ORDEM_COMPRA: return "ORDEM_COMPRA";
    case LogTipoTabela.ORDEM_COMPRA_PRODUTO_SERVICO: return "ORDEM_COMPRA_PRODUTO_SERVICO";
    case LogTipoTabela.PERMISSAO_GRUPO_TELA: return "PERMISSAO_GRUPO_TELA";
    case LogTipoTabela.PESQUISA_SATISFACAO: return "PESQUISA_SATISFACAO";
    case LogTipoTabela.PESQUISA_SATISFACAO_CLIENTE: return "PESQUISA_SATISFACAO_CLIENTE";
    case LogTipoTabela.PGTO_COLETA: return "PGTO_COLETA";
    case LogTipoTabela.PGTO_CONTRATO_FINANCEIRO: return "PGTO_CONTRATO_FINANCEIRO";
    case LogTipoTabela.PGTO_MEDICAO: return "PGTO_MEDICAO";
    case LogTipoTabela.PLANEJAMENTO: return "PLANEJAMENTO";
    case LogTipoTabela.PLANO_TREINAMENTO: return "PLANO_TREINAMENTO";
    case LogTipoTabela.PROCESSO: return "PROCESSO";
    case LogTipoTabela.PROCESSO_AUDITORIA: return "PROCESSO_AUDITORIA";
    case LogTipoTabela.PRODUTO_SERVICO: return "PRODUTO_SERVICO";
    case LogTipoTabela.PRODUTO_SERVICO_ENTREGUE: return "PRODUTO_SERVICO_ENTREGUE";
    case LogTipoTabela.PROJETO: return "PROJETO";
    case LogTipoTabela.PROJETO_ARQUIVO: return "PROJETO_ARQUIVO";
    case LogTipoTabela.PROJETO_IMPRESSAO: return "PROJETO_IMPRESSAO";
    case LogTipoTabela.PROJETO_IMPRESSAO_DISCIPLINA: return "PROJETO_IMPRESSAO_DISCIPLINA";
    case LogTipoTabela.PROJETO_REVISAO: return "PROJETO_REVISAO";
    case LogTipoTabela.PROJETO_REVISAO_DISCIPLINA: return "PROJETO_REVISAO_DISCIPLINA";
    case LogTipoTabela.PROVISAO_RECURSO: return "PROVISAO_RECURSO";
    case LogTipoTabela.QUALIFICACAO: return "QUALIFICACAO";
    case LogTipoTabela.QUALIFICACAO_FORNECEDOR: return "QUALIFICACAO_FORNECEDOR";
    case LogTipoTabela.RATEIO_GERAL: return "RATEIO_GERAL";
    case LogTipoTabela.REAJUSTE: return "REAJUSTE";
    case LogTipoTabela.REQUISICAO_COMPRA: return "REQUISICAO_COMPRA";
    case LogTipoTabela.REQUISICAO_PRODUTO_SERVICO: return "REQUISICAO_PRODUTO_SERVICO";
    case LogTipoTabela.SAIDA_PRODUTO: return "SAIDA_PRODUTO";
    case LogTipoTabela.SALDO_BANCARIO: return "SALDO_BANCARIO";
    case LogTipoTabela.SATISFACAO_CLIENTE: return "SATISFACAO_CLIENTE";
    case LogTipoTabela.SEGURANCA_TRABALHO: return "SEGURANCA_TRABALHO";
    case LogTipoTabela.SERVICOS_CONTROLADOS: return "SERVICOS_CONTROLADOS";
    case LogTipoTabela.SESSAO_ACESSO: return "SESSAO_ACESSO";
    case LogTipoTabela.SETOR: return "SETOR";
    case LogTipoTabela.STATUS_ENVIO_EMAIL: return "STATUS_ENVIO_EMAIL";
    case LogTipoTabela.SUB_DISCIPLINA: return "SUB_DISCIPLINA";
    case LogTipoTabela.SUB_DISCIPLINA_CHECKLIST: return "SUB_DISCIPLINA_CHECKLIST";
    case LogTipoTabela.SUB_DISCIPLINA_ITEM_CHECKLIST: return "SUB_DISCIPLINA_ITEM_CHECKLIST";
    case LogTipoTabela.SUBCONTA: return "SUBCONTA";
    case LogTipoTabela.TELA_SISTEMA: return "TELA_SISTEMA";
    case LogTipoTabela.TEMP_FUNC_TERC: return "TEMP_FUNC_TERC";
    case LogTipoTabela.TEMP_IDEAL: return "TEMP_IDEAL";
    case LogTipoTabela.TERMO: return "TERMO";
    case LogTipoTabela.TIPO_CONTA: return "TIPO_CONTA";
    case LogTipoTabela.TIPO_EXAME: return "TIPO_EXAME";
    case LogTipoTabela.TREINAMENTO: return "TREINAMENTO";
    case LogTipoTabela.USUARIO: return "USUARIO";
    case LogTipoTabela.USUARIO_CENTRO_CUSTO: return "USUARIO_CENTRO_CUSTO";
    case LogTipoTabela.USUARIO_GRUPO: return "USUARIO_GRUPO";
    case LogTipoTabela.VERIFICACAO_CHECKLIST: return "VERIFICACAO_CHECKLIST";
    case LogTipoTabela.EMPREENDIMENTO: return "EMPREENDIMENTO";
    case LogTipoTabela.INCORPORACAO_ANDAR: return "INCORPORACAO_ANDAR";
    case LogTipoTabela.INCORPORACAO_IMOVEL: return "INCORPORACAO_IMOVEL";
    case LogTipoTabela.INCORPORACAO_BLOCO: return "INCORPORACAO_BLOCO";
    case LogTipoTabela.CONTAS_RECEBER_PARCIAL: return "CONTAS_RECEBER_PARCIAL";
    case LogTipoTabela.PROJETO_REVISAO_RESUMO: return "PROJETO_REVISAO_RESUMO";
    case LogTipoTabela.MANUTENCAO: return "MANUTENCAO";
    case LogTipoTabela.CHECKLIST_ENTREGA_AMBIENTE: return "CHECKLIST_ENTREGA_AMBIENTE";
    case LogTipoTabela.EQUIPAMENTO_MEDICAO_HISTORICO: return "EQUIPAMENTO_MEDICAO_HISTORICO";
    case LogTipoTabela.CADASTRO_COR: return "CADASTRO_COR";
    case LogTipoTabela.GESTAO_EPI: return "GESTAO_EPI";
    case LogTipoTabela.GESTAO_RECEBIMENTO_EPI: return "GESTAO_RECEBIMENTO_EPI";
    case LogTipoTabela.GESTAO_DISTRIBUICAO_EPI: return "GESTAO_DISTRIBUICAO_EPI";
    case LogTipoTabela.CHECKLIST_SERVICO_AMBIENTE: return "CHECKLIST_SERVICO_AMBIENTE";
    case LogTipoTabela.BIOMETRIA_FACIAL: return "BIOMETRIA_FACIAL";
    case LogTipoTabela.COLETA_PRECO_APROVADOR: return "COLETA_PRECO_APROVADOR";
    case LogTipoTabela.FUNCIONARIO_APROVADOR: return "FUNCIONARIO_APROVADOR";
    case LogTipoTabela.CHECKLIST_MAQUINA_EQUIP: return "CHECKLIST_MAQUINA_EQUIP";
    case LogTipoTabela.ITEM_CHECKLIST_MAQUINA_EQUIP: return "ITEM_CHECKLIST_MAQUINA_EQUIP";
    case LogTipoTabela.PATRIMONIO_CENTRO_CUSTO: return "PATRIMONIO_CENTRO_CUSTO";
    case LogTipoTabela.PATRIMONIO_MAQUINA_EQUIP: return "PATRIMONIO_MAQUINA_EQUIP";
    case LogTipoTabela.PATRIMONIO_CHECKLIST_MAQUINA_EQUIP: return "PATRIMONIO_CHECKLIST_MAQUINA_EQUIP";
    case LogTipoTabela.INSPECAO_PATRIMONIO: return "INSPECAO_PATRIMONIO";
    case LogTipoTabela.INSPECAO_PATRIMONIO_ITENS: return "INSPECAO_PATRIMONIO_ITENS";
    case LogTipoTabela.OCORRENCIA_INSPECAO_PATRIMONIO: return "OCORRENCIA_INSPECAO_PATRIMONIO";
    case LogTipoTabela.CHECKLIST_SERVICO_LIBERACAO: return "CHECKLIST_SERVICO_LIBERACAO";
  }
}

/**
 * logTipoAcaoToString
 */

export const logTipoAcaoToString = (logTipoAcao: LogTipoAcao): string => {
  switch (logTipoAcao) {
    case LogTipoAcao.INCLUSAO: return "INCLUSAO";
    case LogTipoAcao.EDICAO: return "EDICAO";
    case LogTipoAcao.DELECAO: return "DELECAO";
    case LogTipoAcao.RESTAURACAO: return "RESTAURACAO";
  }
}